// extracted by mini-css-extract-plugin
export default {"wrap":"PolicyContainer_wrap__Mi+EE","pageHeader":"PolicyContainer_pageHeader__kY0oe","pageGuide":"PolicyContainer_pageGuide__391Br"};